// export const captcha = '6LeYiIMhAAAAABJ7oj3Y7dl4APQGQqTO26dmrb1O';
export const captcha = window.app_config.googleCaptcha;
